import React from "react";
import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive'
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import logo from './Assets/Images/dream4IconLogo.png';
import './App.css';

//theme
import "./Assets/Styles/theme-primereact.css"; 

//core
import "primereact/resources/primereact.min.css";

//icons
import "primeicons/primeicons.css";  

import DesktopLayout from './Layouts/Desktop';
import MobileLayout from './Layouts/Mobile';
import PaymentLinkPublic from './Screens/Public/PaymentLink';
import HotelViewPublic from './Screens/Public/HotelView';
import QuoteSelectionPublic from './Screens/Public/QuoteSelection';

import ReCAPTCHA from "react-google-recaptcha"
import * as Config from './Config/api';
import env from './Config/env';
import { isPublicHost } from './Utils/publicUrl';

function App() {

  // Breakpoint Desktop/Mobile por tipo de usuário: master (header ocupa mais espaço
  // com o SUDO) vira mobile abaixo de 1140px; agência normal, abaixo de 1024px.
  const masterUser = useSelector((s) => s.appReducer?.masterUser);
  const atLeast1024 = useMediaQuery({ query: '(min-width: 1024px)' });
  const atLeast1140 = useMediaQuery({ query: '(min-width: 1140px)' });
  const isDesktopOrLaptop = masterUser ? atLeast1140 : atLeast1024;
  const isTabletOrMobile = !isDesktopOrLaptop;
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })	
	
  const recaptchaRef = React.useRef(null);

  // Domínio público dedicado: só as rotas públicas são servidas; a B2B nunca renderiza.
  const publicOnly = isPublicHost();

  return (
    <div className="App">
      <Routes>
        {/* Página pública de pagamento — fora do layout da agência (sem header/menu/redirect) */}
        <Route path="/pagamento/:token" element={<PaymentLinkPublic />} />

        {/* Página pública de visualização de hotel — sem SEO, fora do layout.
            Token OPACO: a URL NÃO revela o fornecedor nem o id cru (o backend resolve
            token -> hotel + agência). Nunca expor hyperguest/priceline. */}
        <Route path="/hotel/:token" element={<HotelViewPublic />} />

        {/* Página pública de SELEÇÃO+APROVAÇÃO da cotação (Fase 2) — fora do layout.
            Cliente resolve as opções (um quarto por trecho) e aprova. Token opaco. */}
        <Route path="/cotacao/:token" element={<QuoteSelectionPublic />} />

        {/* Resto do app: layout normal da agência — MAS, no domínio público dedicado,
            nada de B2B: qualquer outra rota vira uma 404 neutra (o usuário não "sai"
            do path e cai no site B2B). */}
        <Route
          path="*"
          element={publicOnly ? (
            <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "#F2F4F7", color: "#2E0249", textAlign: "center", padding: "2rem", fontFamily: "Poppins, sans-serif" }}>
              <h1 style={{ fontSize: "1.4rem", marginBottom: "0.5rem" }}>Página não encontrada</h1>
              <p style={{ color: "#6B6B6B", margin: 0 }}>Este endereço serve apenas links de pagamento e de hotéis.</p>
            </div>
          ) : (
            <>
              <div>
                {isDesktopOrLaptop && <DesktopLayout />}
                {isTabletOrMobile && <MobileLayout />}
              </div>
              <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                badge="bottomleft" /*inline*/
                sitekey={Config.REACT_APP_SITE_KEY}
              />

              <FloatingWhatsApp
                phoneNumber={env.WHATSAPP_PHONE}
                accountName="Suporte Dream4"
                allowClickAway={true}
                chatMessage="Olá! Caso tenha dúvidas sobre cadastro ou reserva, fale conosco via whatsapp!"
                statusMessage="Fale conosco quando precisar"
                placeholder="Digite sua mensagem aqui..."
                avatar={logo}
                notification={true}
                notificationSound={true}
                notificationDelay={5000}
                chatboxStyle={{ width: '450px', height: '300px' }}
                style={{ bottom: '5rem', right: '20px' }}
                buttonStyle={{ bottom:"6rem" }}
              />
            </>
          )}
        />
      </Routes>
    </div>
  );
}

export default App;
